<!-- PrimeNG Dialog component wrapper -->
<p-dialog
    class="modal-wrapper"
    [(visible)]="isVisible"
    [header]="headerRef() ? '' : header()"
    [showHeader]="showHeader()"
    [closable]="showCloseButton()"
    [dismissableMask]="dismissableMask()"
    [modal]="true"
    [appendTo]="isAppendedToBody() ? 'body' : null"
    [focusOnShow]="focusOnShow()"
    [draggable]="false"
    [resizable]="false"
    [blockScroll]="blockScroll()"
    [closeAriaLabel]="'סגור את תיבת הדו-שיח'"
    [styleClass]="styleClass()"
    (onShow)="handleShow()"
    (onHide)="handleHide()"
>
    <!-- Custom projected header template -->
    @if (headerRef()) {
        <ng-template pTemplate="header">
            <div class="modal__header">
                <ng-container [ngTemplateOutlet]="headerRef()!"></ng-container>
            </div>
        </ng-template>
    }

    <!-- Custom close icon template -->
    @if (showCloseButton()) {
        <ng-template pTemplate="closeicon">
            <span class="modal__close-icon fa-regular fa-xmark" aria-hidden="true"></span>
        </ng-template>
    }

    <!-- Projected main body content -->
    <ng-content></ng-content>

    <!-- Plain text modal message body -->
    @if (modalText()) {
        <div class="modal__text">{{ modalText() }}</div>
    }

    <!-- Custom projected footer template -->
    @if (footerRef()) {
        <ng-template pTemplate="footer">
            <div class="modal__footer">
                <ng-container [ngTemplateOutlet]="footerRef()!"></ng-container>
            </div>
        </ng-template>
    }
</p-dialog>
